import { render, staticRenderFns } from "./scrmTagPicker.vue?vue&type=template&id=2c8972cc&scoped=true&"
import script from "./scrmTagPicker.vue?vue&type=script&lang=js&"
export * from "./scrmTagPicker.vue?vue&type=script&lang=js&"
import style0 from "./scrmTagPicker.vue?vue&type=style&index=0&id=2c8972cc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8972cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c8972cc')) {
      api.createRecord('2c8972cc', component.options)
    } else {
      api.reload('2c8972cc', component.options)
    }
    module.hot.accept("./scrmTagPicker.vue?vue&type=template&id=2c8972cc&scoped=true&", function () {
      api.rerender('2c8972cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/picker/scrmTagPicker.vue"
export default component.exports